import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm, SubmitHandler } from "react-hook-form";
// import '../css/registre.css';
import logo from '../image/logo.png';
import test1 from '../image/test-2.gif';
import { resetPassword } from '../services/Passwoard_service';
import { faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';


type FormInputs = {
newPassword: string;
confirmPassword: string;
};

const PasswordReset: React.FC = () => {
const { register, handleSubmit, formState: { errors }, reset } = useForm<FormInputs>();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [userId, setUserId] = useState<string | null>(null);
    const navigate = useNavigate();

    const handleLogoClick = () => {
        localStorage.clear();
        navigate('/login');
    };

        const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
        };

        const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
        };

        useEffect(() => {
        // Récupérez l'ID de l'utilisateur à partir de localStorage
        const storedUserId = localStorage.getItem('userId');
        setUserId(storedUserId);
        }, []);

        const onSubmit: SubmitHandler<FormInputs> = async (data) => {
            if (data.newPassword !== data.confirmPassword) {
            toast.error('Les mots de passe ne correspondent pas');
            return;
            }

            if (!userId) {
            toast.error('ID utilisateur non trouvé');
            return;
            }

            try {
            const requestData = {
            id: userId,
            newPassword: data.newPassword
            };

            await resetPassword(requestData);
            toast.success('Mot de passe réinitialisé avec succès');
            reset();
            setTimeout(() => {
            localStorage.clear();
            window.location.replace('/login');
            }, 1000);
            } catch (error: any) {
            console.error('Erreur lors de la réinitialisation du mot de passe :', error);
            toast.error(error.message || 'Une erreur est survenue lors de la réinitialisation du mot de passe');
            }
            };

            return (
            <>
                <ToastContainer />
                <div className="degrade-vertical big-height">
                    {/* logo */}
                    <div className="row d-flex justify-content-center align-items-center vh-100">
                        <div className="col-md-6 col-sm-12 d-flex section-txt">
                            <div className="bg-section">
                            <div className="img-animate">
                                <img src={test1} alt="gif" className="img-fluid w-100" />
                            </div>
                                <div className="text-title mb-5">
                                    <h1 className="font-1">Annonce Legale <br /> Officielle</h1>
                                    <p className="font-2 ">Bénéficiez d’une publication instantanée dans toute la
                                        France,
                                        grâce à notre plateforme sécurisée en ligne, disponible 24/7 et adaptée à tout
                                        type
                                        d’annonce, des plus simples aux plus complexes.</p>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6 col-sm-12  bg-dark-login d-flex section-txt">
                            <div className="p-3">
                                <img src={logo} className="my-2 ml-3 logo-1" alt="logo" />
                            </div>
                            <form className="form-login pb-4 px-5 pt-4 d-flex flex-column"
                                onSubmit={handleSubmit(onSubmit)}>
                                <p className="txt-login mb-4">Rénitialisation</p>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">
                                            <FontAwesomeIcon icon={faLock} aria-hidden="true" className="ico" />
                                        </span>
                                    </div>
                                    <input className="form-control" type={showPassword ? "text" : "password" }
                                        placeholder="Nouveau mot de passe" aria-label="Nouveau mot de passe"
                                        aria-describedby="basic-addon1" {...register('newPassword', {
                                        required: 'Le nouveau mot de passe est requis' })}
                                        style={{ marginRight: '-7px', fontSize: '16px' }} />
                                    <div className="input-group-append">
                                        <span className="input-group-text" onClick={togglePasswordVisibility}
                                            style={{ cursor: 'pointer' }}>
                                            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} aria-hidden="true"
                                                className="ico" />
                                        </span>
                                    </div>
                                </div>
                                {errors.newPassword && <p className="error-message">{errors.newPassword.message}</p>}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">
                                            <FontAwesomeIcon icon={faLock} aria-hidden="true" className="ico" />
                                        </span>
                                    </div>
                                    <input className="form-control" type={showConfirmPassword ? "text" : "password" }
                                        placeholder="Confirmer le mot de passe" aria-label="Confirmer le mot de passe"
                                        aria-describedby="basic-addon1" {...register('confirmPassword', {
                                        required: 'La confirmation du mot de passe est requise' })}
                                        style={{ marginRight: '-7px', fontSize: '16px' }} />
                                    <div className="input-group-append">
                                        <span className="input-group-text" onClick={toggleConfirmPasswordVisibility}
                                            style={{ cursor: 'pointer' }}>
                                            <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash}
                                                aria-hidden="true" className="ico" />
                                        </span>
                                    </div>
                                </div>
                                {errors.confirmPassword && <p className="error-message">{errors.confirmPassword.message}
                                </p>}
                                <button type="submit" className="btn btn-1">Envoyer</button>
                            </form>
                        </div>
                    </div>
                </div>
            </>
            );
            };

            export default PasswordReset;